<template>
    <div id="app">
        <!-- Start Header -->
        <cynexsol_header></cynexsol_header>
        <!-- End Header -->
        <!-- Start Body -->
        <router-view></router-view>
        <!-- End Body -->
        <!-- Start Footer -->
        <cynexsol_footer></cynexsol_footer>
        <!-- End Footer -->
    </div>
</template>
<!-- Animate CSS -->
<style src="animate.css/animate.css"></style>
<!-- Material Icon CSS -->
<style src="./assets/css/materialdesignicons.min.css"></style>
<!-- Main Style CSS -->
<style src="./assets/css/style.css"></style>
<!-- Main App Js -->
<script src="./app.js"></script>
